// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1dKFJ","info":"PatientInfo_info__HVOH-"};